import { summarizeOrderSpecifiedPaymentTotal } from "@/utils/orderSpecifiedPaymentTotal";

export interface PaymentCardSummary {
  initialOrderCount: number;
  actualOrderCount: number;
  initialItemCount: number;
  actualItemCount: number;
  initialProductAmount: number;
  actualProductAmount: number;
  initialShippingAmount: number;
  actualShippingAmount: number;
  initialDiscountAmount: number;
  actualDiscountAmount: number;
  initialCouponAmount: number;
  actualCouponAmount: number;
  initialOrderCompositionAmount: number;
  actualOrderCompositionAmount: number;
}

const FINAL_PAYMENT_EXCLUDED_ITEM_STATUSES = new Set([
  "C35",
  "C40",
  "C41",
  "C42",
  "C43",
  "C47",
  "C48",
  "C49",
  "R40",
  "R41",
  "R42",
  "R43",
]);

function getOrderItems(order: any): any[] {
  return Array.isArray(order?.items) ? order.items : [];
}

function getActualItems(order: any): any[] {
  return getOrderItems(order).filter(
    (item) =>
      !FINAL_PAYMENT_EXCLUDED_ITEM_STATUSES.has(
        String(item?.order_status || "")
          .trim()
          .toUpperCase()
      )
  );
}

export function summarizePaymentCard(orders: any[]): PaymentCardSummary {
  const sourceOrders = Array.isArray(orders) ? orders : [];
  const initial = summarizeOrderSpecifiedPaymentTotal(sourceOrders);
  const actualOrders = sourceOrders.map((order) => ({
    ...order,
    initial_order_amount: order?.actual_order_amount,
    items: getActualItems(order),
  }));
  const actual = summarizeOrderSpecifiedPaymentTotal(actualOrders);
  const initialItemCount = sourceOrders.reduce(
    (count, order) => count + getOrderItems(order).length,
    0
  );
  const actualItemCount = actualOrders.reduce(
    (count, order) => count + getOrderItems(order).length,
    0
  );
  const actualOrderCount = sourceOrders.reduce((count, order, index) => {
    const initialItems = getOrderItems(order);
    const actualItems = getOrderItems(actualOrders[index]);
    const isFullyExcluded = initialItems.length > 0 && actualItems.length === 0;
    return count + (isFullyExcluded ? 0 : 1);
  }, 0);

  return {
    initialOrderCount: sourceOrders.length,
    actualOrderCount,
    initialItemCount,
    actualItemCount,
    initialProductAmount: initial.productAmount,
    actualProductAmount: actual.productAmount,
    initialShippingAmount: initial.shippingAmount,
    actualShippingAmount: actual.shippingAmount,
    initialDiscountAmount: initial.discountAmount,
    actualDiscountAmount: actual.discountAmount,
    initialCouponAmount: initial.couponAmount,
    actualCouponAmount: actual.couponAmount,
    initialOrderCompositionAmount: initial.totalAmount,
    actualOrderCompositionAmount: actual.totalAmount,
  };
}
